
import React, { useState } from 'react';
import './DragDropMultipleImagePreview.css';

const DragDropMultipleImagePreview = () => {
  const [dragActive, setDragActive] = useState(false);
  const [images, setImages] = useState([]);

  const handleDragOver = (e) => {
    e.preventDefault();
    setDragActive(true);
  };

  const handleDragLeave = (e) => {
    e.preventDefault();
    setDragActive(false);
  };

  const handleDrop = (e) => {
    e.preventDefault();
    setDragActive(false);

    const files = Array.from(e.dataTransfer.files);
    processFiles(files);
  };

  const handleFileChange = (e) => {
    const files = Array.from(e.target.files);
    processFiles(files);
  };

  const processFiles = (files) => {
    const imageFiles = files.filter((file) => file.type.startsWith('image/'));
    const imagePreviews = imageFiles.map((file) => {
      const reader = new FileReader();
      return new Promise((resolve) => {
        reader.onload = (event) => resolve({ name: file.name, src: event.target.result });
        reader.readAsDataURL(file);
      });
    });

    Promise.all(imagePreviews).then((newImages) => {
      setImages((prevImages) => [...prevImages, ...newImages]);
    });
  };

  return (
    <div>
      <div
        className={`drag-drop-box ${dragActive ? 'drag-active' : ''}`}
        onDragOver={handleDragOver}
        onDragLeave={handleDragLeave}
        onDrop={handleDrop}
      >
        <p>Drag and drop images here, or click to select files</p>
        <input
          type="file"
          className="file-input"
          accept="image/*"
          multiple
          onChange={handleFileChange}
        />
      </div>
      <div className="image-preview-grid">
        {images.map((image, index) => (
          <div key={index} className="image-preview-item">
            <img src={image.src} alt={image.name} className="image-preview" />
            <p>{image.name}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default DragDropMultipleImagePreview;
